import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  Button,
  Breadcrumbs,
  Link,
  Chip,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Home, Work, Email, LocationOn, Schedule } from '@mui/icons-material';

const CareersPage = () => {
  const jobOpenings = [
    {
      title: 'Sales Executive',
      department: 'Sales',
      location: 'Mumbai',
      type: 'Full-time',
      description: 'Join our sales team to help customers find the perfect stones for their projects.',
    },
    {
      title: 'Quality Inspector',
      department: 'Operations',
      location: 'Delhi',
      type: 'Full-time',
      description: 'Ensure our products meet the highest quality standards before delivery.',
    },
    {
      title: 'Customer Support Representative',
      department: 'Support',
      location: 'Remote',
      type: 'Full-time',
      description: 'Provide excellent customer service and support to our valued clients.',
    },
  ];

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50', py: 4 }}>
      <Container maxWidth="lg">
        {/* Breadcrumbs */}
        <Breadcrumbs sx={{ mb: 3 }}>
          <Link component={RouterLink} to="/" color="inherit" sx={{ display: 'flex', alignItems: 'center' }}>
            <Home sx={{ mr: 0.5 }} fontSize="inherit" />
            Home
          </Link>
          <Typography color="text.primary">Careers</Typography>
        </Breadcrumbs>

        {/* Header */}
        <Paper elevation={0} sx={{ p: 4, mb: 4, textAlign: 'center', bgcolor: 'primary.main', color: 'white' }}>
          <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
            Join Our Team
          </Typography>
          <Typography variant="h6" sx={{ opacity: 0.9 }}>
            Build your career with Mall of Stones
          </Typography>
        </Paper>

        <Grid container spacing={4}>
          {/* Main Content */}
          <Grid item xs={12} md={8}>
            <Paper elevation={1} sx={{ p: 4, mb: 4 }}>
              <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', fontWeight: 600 }}>
                Why Work With Us?
              </Typography>
              
              <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                At Mall of Stones, we believe our people are our greatest asset. We offer a dynamic work 
                environment where innovation meets tradition, and every team member contributes to our 
                mission of delivering exceptional stone products to our customers.
              </Typography>

              <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                We provide competitive compensation, growth opportunities, and a collaborative culture 
                that values integrity, quality, and customer satisfaction.
              </Typography>
            </Paper>

            {/* Job Openings */}
            <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', fontWeight: 600, mb: 3 }}>
              Current Openings
            </Typography>

            {jobOpenings.map((job, index) => (
              <Card key={index} elevation={1} sx={{ mb: 3 }}>
                <CardContent sx={{ p: 3 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                    <Box>
                      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                        {job.title}
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                        <Chip label={job.department} size="small" color="primary" variant="outlined" />
                        <Chip label={job.type} size="small" color="secondary" variant="outlined" />
                      </Box>
                    </Box>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, color: 'text.secondary' }}>
                    <LocationOn sx={{ fontSize: 16, mr: 1 }} />
                    <Typography variant="body2">{job.location}</Typography>
                  </Box>

                  <Typography variant="body2" color="text.secondary" paragraph>
                    {job.description}
                  </Typography>

                  <Button variant="outlined" color="primary" size="small">
                    Apply Now
                  </Button>
                </CardContent>
              </Card>
            ))}
          </Grid>

          {/* Sidebar */}
          <Grid item xs={12} md={4}>
            <Card elevation={1} sx={{ mb: 3 }}>
              <CardContent sx={{ p: 3 }}>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                  <Work sx={{ mr: 1, verticalAlign: 'middle' }} />
                  Benefits
                </Typography>
                <Box component="ul" sx={{ pl: 2, m: 0 }}>
                  <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                    Competitive salary packages
                  </Typography>
                  <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                    Health insurance coverage
                  </Typography>
                  <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                    Professional development opportunities
                  </Typography>
                  <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                    Flexible working arrangements
                  </Typography>
                  <Typography component="li" variant="body2">
                    Performance-based incentives
                  </Typography>
                </Box>
              </CardContent>
            </Card>

            <Card elevation={1}>
              <CardContent sx={{ p: 3 }}>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                  <Email sx={{ mr: 1, verticalAlign: 'middle' }} />
                  Get in Touch
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                  Don't see a position that fits? Send us your resume and we'll keep you in mind for future opportunities.
                </Typography>
                <Button 
                  variant="contained" 
                  color="primary" 
                  fullWidth
                  href="mailto:careers@mallofstones.com"
                  sx={{ mt: 2 }}
                >
                  Send Resume
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default CareersPage;